import { HelpMessage, HelpTitle, Href } from "../../../../../Constants/Constants";
import { HelpData } from "../../../../../Data/Messenger/Messenger";
import { useAppSelector } from "../../../../../ReduxToolkit/Hooks";
import CommonMediaHeading from "./Common/CommonMediaHeading";

const Help = () => {
  const { settingsActiveTab } = useAppSelector((state) => state.mainSidebar);
  return (
    <div className="setting-block">
      <div className={`block ${settingsActiveTab === "help" ? "open" : ""}`}>
        <CommonMediaHeading title={HelpTitle} />
        <ul className="help">
          {HelpData.map((item, index) => (
            <li key={index}>
              <h5>
                <a href={Href}>{item}</a>
              </h5>
            </li>
          ))}
        </ul>
      </div>
      <CommonMediaHeading title={HelpTitle} text={HelpMessage} type="help" />
    </div>
  );
};

export default Help;
